
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.resources-banner {
  display: grid;
  grid-template-areas:
    'middle'
    'right'
    'left';
  text-align: center;
  width: 80vw;
  margin: 0 auto;

  &__wrapper {
    width: 100vw;
    margin: 2rem 0;
  }
}

.banner-middle-item {
  grid-area: middle;
  display: grid;
  width: 100%;

  &__subheading {
    padding: 1rem 0 2.5rem 0;

    span,
    div {
      font-size: 1rem;
    }
  }
}

.banner-left-image {
  grid-area: left;
  width: 75%;
  margin: 0 auto;
}

.banner-right-image {
  grid-area: right;
  display: none;
}

@include media-query(tablet) {
  .banner-middle-item__subheading {
    padding: 1rem 0 2.5rem 0;

    span,
    div {
      font-size: 1.5rem;
    }
  }
}

@include media-query(desktop) {
  .resources-banner {
    grid-template-areas: none;
    grid-template-columns: [left] 1fr [middle] 50% [right] 1fr;
    align-items: flex-end;
    width: 90vw;
    margin: auto;

    &__wrapper {
      padding-bottom: 3.75rem;
    }
  }

  .banner-middle-item {
    padding: 0 1.25rem;
    width: 90%;
    margin: 0 auto;

    &__heading,
    &__subheading {
      margin: 0 auto;
      padding-bottom: 0.625rem;
    }

    &__subheading {
      display: flex;
      align-items: flex-end;
    }
  }

  .banner-left-image,
  .banner-right-image {
    width: 100%;
  }

  .banner-right-image {
    display: block;
  }
}
`